export const LAMBDATEST_DELETE_LOADING = "LAMBDATEST_DELETE_LOADING";
export const LAMBDATEST_DELETE_SUCCESS = "LAMBDATEST_DELETE_SUCCESS";
export const LAMBDATEST_DELETE_FAILED = "LAMBDATEST_DELETE_FAILED";
export const LAMBDATEST_DELETE_CLEAR = "LAMBDATEST_DELETE_CLEAR";
